import React from "react";

import { BranchesCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function branches({ width, onResize }: Column.Options) {
	return base(ColumnId.Branches, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default branches;
